import { useKeycloak } from '@react-keycloak/web';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';

import { ROUTES } from '@/config/routes';
import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';
import { ErrorPage } from '@/shared/ui/ErrorPage/ErrorPage';

function NotFound() {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const userType = useContext(UserTypeContext);

  const goHome = () => {
    let subdomain = '';

    switch (userType) {
      case 'location':
        subdomain = 'location';
        break;
      case 'service':
        subdomain = 'services';
        break;
      case 'advertiser':
        subdomain = 'advertiser';
        break;
      default:
        subdomain = 'backoffice';
    }

    if (window.location.origin.includes(`${subdomain}.`)) {
      navigate(ROUTES.AUTHORIZED.LANDING);
    } else {
      window.location.href = window.location.origin.replace(
        /^(https?:\/\/)?([^./]+)/,
        (_, protocol = '') => {
          return `${protocol}${subdomain}`;
        },
      );
    }
  };

  if (!keycloak?.authenticated) return null;

  return (
    <div data-testid="not-found">
      <ErrorPage
        variant="notFound"
        fullScreen
        actions={
          <Button variant="text" sx={{ fontSize: '1rem' }} onClick={goHome}>
            {t('return_home')}
          </Button>
        }
      />
    </div>
  );
}

export default NotFound;
